// extracted by mini-css-extract-plugin
export var column = "index-module--column--oMVDy";
export var copyrightText = "index-module--copyrightText--gq3B5";
export var footerGrid = "index-module--footerGrid--fSSap";
export var link = "index-module--link--P78zf";
export var logo = "index-module--logo--txm2o";
export var logoContainer = "index-module--logoContainer--0y9xU";
export var logoLink = "index-module--logoLink--X4Nu6";
export var logoSection = "index-module--logoSection--GdZit";
export var mobileButtonContainer = "index-module--mobileButtonContainer--uSayj";
export var mobileLogoContainer = "index-module--mobileLogoContainer--lZUI3";
export var mobileLogoSection = "index-module--mobileLogoSection--6q45l";
export var mobileOuterLogoContainer = "index-module--mobileOuterLogoContainer--gW6cB";
export var mobileRightLogoContainer = "index-module--mobileRightLogoContainer--d2zEb";
export var sublinks = "index-module--sublinks--Xyk-Z";
export var termsAndPrivacy = "index-module--termsAndPrivacy--fxorR";